/**
 * LiveVoice — la voix d'un participant sur sa vignette, et sur le bouton de mon micro, au web comme au natif, chez
 * l'élève comme chez le tuteur (weekly du 03/11).
 *
 * Les barres lisent ce que LiveKit diffuse déjà (`engine/live/room/speakingBars`) : aucun analyseur audio par
 * vignette (décision du 03/11). Elles ondulent pendant qu'il parle, plus amples quand il parle fort, et restent au
 * repos sinon. C'est le seul élément qui bouge au rythme de la voix, sans redessin : l'écran le pose dans la fente
 * des vignettes (`VoiceSlotContext`), et la salle ne lit jamais le niveau.
 */
import React, { useMemo } from "react"

import { VoiceBars } from "../../../../../../design-system"
import { listenSpeakingBars } from "../../../../../../engine/live/room/speakingBars"
import { useVoiceTrack } from "../../../../../../engine/live/room/useVoiceTrack"

export type LiveVoiceProps = {
    /** L'id de la vignette : celui de la personne, avant le point de son identité LiveKit. */
    personId: string
    /** La hauteur des barres. Défaut : celle de `<VoiceBars>`. */
    size?: number
}

export function LiveVoice({ personId, size }: LiveVoiceProps) {
    const voice = useVoiceTrack(personId)
    const participant = voice?.track == null ? undefined : voice.participant
    const feed = useMemo(
        () =>
            participant == null
                ? undefined
                : (push: (levels: readonly number[]) => void) => listenSpeakingBars(participant, push),
        [participant]
    )
    return feed == null ? null : <VoiceBars feed={feed} size={size} />
}
